/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { DeleteAccountWebpushMutationRequest, DeleteAccountWebpushMutationResponse } from '../types/DeleteAccountWebpush.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getDeleteAccountWebpushUrl() {
  const res = { method: 'DELETE', url: `/account/webpush` as const };
  return res;
}

/**
 * @description Delete account webpush association
 * @summary Delete account webpush association
 * {@link /account/webpush}
 */
export async function deleteAccountWebpush(
  data: DeleteAccountWebpushMutationRequest,
  config: Partial<RequestConfig<DeleteAccountWebpushMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<DeleteAccountWebpushMutationResponse, ResponseErrorConfig<Error>, DeleteAccountWebpushMutationRequest>({
    method: 'DELETE',
    url: getDeleteAccountWebpushUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
